// Module
var code = "<div class=\"avatar-container\" ng-click=\"vm.handleClick($event)\"> <img class=\"avatar\" ng-src=\"{{vm.thumbnail}}\" alt=\"{{vm.name}}\" ng-style=\"{'visibility': vm.loaded ? 'visible' : 'hidden'}\"> <img ng-if=\"!vm.loaded\" class=\"image-loading-icon\" ng-src=\"/assets/images/animated-spinner.svg\" alt=\"loader\"> </div> ";
// Exports
module.exports = code;